import React, { useState } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import lifecycle from 'react-pure-lifecycle';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  TextField,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper

} from '@material-ui/core';

import { DropzoneArea } from 'material-ui-dropzone'
var fileTypes = ['jpg', 'jpeg', 'png', 'what', 'ever', 'you', 'want'];  //acceptable file types

var mime = require('mime-types')
var sha512 = require('js-sha512');
var download = require("downloadjs");
let objectURL;

//--------------------------------
// editing ficha tecnica 
let descricaoEditing;
let nomeEquipEditing;
let ficheirosDSEditing = []; 
let imagensEditing;
let idEditing;
let tipoFichaTecnicaEditing;
let tipoManualEditing; 
// -------------------------------
let fileCenas = [];
const imageDataUrl = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxISEhUTEhIVFRUVFRUVEBcVFRUPFRUSFRUWFhUVFRUYHSggGBolGxUVITEhJSkrLi4uFx8zODMtNygtLisBCgoKDg0OGxAQGy0mICUtLS0tLS8tLS0uLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLf/AABEIALcBFAMBIgACEQEDEQH/xAAbAAACAwEBAQAAAAAAAAAAAAAEBQACAwEGB//EADkQAAEDAgQEAwcEAgEEAwAAAAEAAhEDIQQSMUEFUWFxIoGRBhMyobHR8BRCweFS8YIjYpLSFTNy/8QAGgEAAwEBAQEAAAAAAAAAAAAAAgMEAQUABv/EAC0RAAICAgICAAQFBAMAAAAAAAABAhEDIRIxBEETIlFhFCMygZFCcfDxBaHR/9oADAMBAAIRAxEAPwDwnDA5PGtMILhtJOW07L6fHGkfLeRkuQFncoSUa2itBh0YjmhQ/Mq5SU4dhlkcOsoJZULBSXXUkxFBd/TLOJvxRFWpELJgTuthkC/CQbIXAfDKmiUaSJFJcoBFQjSFTk7BvdKCjC3KpmWg8mUM81g+mUWFHNXmaptF8HXA1RxxghKXU1wUys5HnsMqcR5BQcQQ/uVQ0l6zPlLV+Ik6IMOcTKKdRAaXHYSvL43ir3nIWhhZOaDZ2kG/lA6+i5ZEmkyvx8Ly/p69npHcSY0eIgnkL/PZA1eNTowX0mTz5dkiBJBtpBG0A/Wcw+SuRr017j+ymLZfDwsUe1Y0pcRaToAOmu23mneEcHNkGQdF41/SADtOn9Xt2RWCxr6RlpIEtkHQyATbnvqsWgM/hqS+TTPXCmrFqx4dj21m5hY/uHI/yEU5wCZRx5RlGVMX4mmqYdqIruCyZZYxieqNKt0vr00cXrF4WPZsG0KX4dZMw10zc1VaxL4IpWV0B/p1EdAUW8EZ8RhXDwnFM2SGlVyotuNCJdEeWDk7GgK2YldHEymNFyInnFo0IVci0C6AhF2Ztpq4pLRoWgC0xsEqUELUohMqhSzG1IWjINtgdUALL36GxWJQgroXKi6OJtbGTqyjHSloqSmGDC8nZ6cOKDKdNa+7VjUaxpc4w0CSTyXm8Z7RPc7weFm3M9T9gtStgYcGTM/l/kfupqzGLzQxjna/n5KJpYoiL33Ou+6b8D7lb/4+Vfq/6Hxak2N421pIY3NFpmBPTmheJcTe8ZQYFwY1JEa9OiVtYJIPlvfafn6oeFdjPH8Ct5N/YZVOLVXgsIYAcoMB0w6/0SJ7c1VxPOCT0gE/JMMkCZBtJAGhMgDp/aGZhra33QPHza10dDHjjjVRVF6cmxJIcQHSYzCxGY+XlCu9hcM7iZPP90QNed12lTbpBcSCLCYOgsNf7RNHBmB7wgNbMNm9zf5wmqFBNgJi5i8b/wCWb52WZYY7nuNPrdF+7a3WSf8Ax1j7qDFxGVrRptyOhnUWXnFGneG1XscDBg67SP6ylOv1pKRsxTn2EkwfTV1l39W7Wdjre/M+aXJ+kyXN4yyO/Y69/KnvUto4wExodtpG3miQ5KtkE8Lg6YUHqpcqByhKKwKISqmpC44rCo5C2Go2XNRRCklRDyGcAhtVdlY0wtcq9ZjSQfgXp7hnWXm8O6CnWEqpsXoi8iPsatVgqUjIWi0hZ1q0BWJdC4aq8ZVna4SXiTTBTjPKFxLAVo3G+LPHuYZuqFpTnE4cShnUEhwOpHMmA0ymmDehxQW9OlCKKaBySUkJuLY19VxE+AfC0adz1QjG6m0DYHnayKxdHxuGhG2hvy5hDCxvtp3CrSS6OtijFQSj0E0GacomenM9eiIqiLCNcpvM7yDy0UoMIaCZ8QBjpm19ZCu1g0IE68jYRHKFrkGCtYCL6l2sjlcHeL/VatojqBFtPi3vujMPhp2A0F7kzyHmu1PciziT2t8l7jfZ6xdWMyG23I6rPD4YvMC3M/m/RMGOo7M+Z+ZWlKqzQMj9xudgTz/JRNa0esqKzKbYpi5BzOOp0jtBkoV1UvJnYHzAkieaJfhQRIdADS7xQJlwESInf0QtQC0TOXxcpk6fL1S7PGLaQOWXR/laY1v9B5LFjHG2WdRGmxJE+RKIeW6HpMXkzfdZO0nrf66IWmwiraRgG8ODgCLTA0vqJhZ0WZiADHchosJNzYK7XkGQSDpOh+XdUe0R1MRtEfg9EtwZ4o6tdpF4Df8AtuBEeG/nqi8HjgYa6ZgXjWYH869ENmIPh/a4uabE7ROx0+ZWFU21sNO9pAQSjQM8amqZ6RrVaFjwqoX05d8QOV3fY+iIqNWHHkmpOLB6pQbjKLeJXG0VlWMi0jFrFEa2ioi4A/EKNpwrBq4yqtgEKQLb9meVGYSpCwDVo1iJC5U1Q6oVUY16SUKkI5mIEJhFOGzfEVEvOJupia6EpiVjDhBVsZ0MQrVHoJjVoSvWY4qylVsrI0lu1bNpr1BcqAxRWgpIXi/F6dDw/E/XLy7leaqccruPxR0ytt2kLyorw+Jkyrl0j1j8I11y0EjQ2MJNxnChpaWgTOnPrCDw+Lqa+8Nxe8m1r+S0q1SS0tBJbcFx/gp8YPuyzF4s8c75aDqdxrcC40EC4kHa30VWVGSLzrAPoNr6IHFV5JDfh2E/ayq2jA2FvE46CDqCjpFpMQ5xcQCRDoE2iVKVAk3vYj6ifVVbiG6g6HXrOoG6s2tmGkAkamTfXy8liaZuxnTwtKxe7bxNb/2jWdpW/vsOyP8ApyCHbxPn3+iWVrOdlJjRsOBnTWALeS4ylYixJAOsQBMjvMIqB9B4r0CIyctzKEr4YExTecm9rzYkdRYaoYUD1F1ZtF3P87r1II2Zg6Q1JPnHorO4fROjnt53Dh077oV1Z/P7E9Vw1yNWiJiRbr9ljR4No8HpkgGqbxEMv5XQ+K4U5oljw8biIcJ6ctFZtQPEh0GdNNQeXYKnvS0Ah15Mi8tiMu3MayfLcGqPWLXDY2joQeyxrgWgzIBPR24TLEVQ74hJ/wAhY26IXiFANIgRYAzE5x8WmyVNaCGfss+Q9s2BaY0GY5pMdoTWtTS/2TpQyo7YuAHcC/1TCvVhJ9HF8l/nyr/NAdVsKtJyzxGICGZiLrFJWGoNoctUQzKtlEzkIcGLcHVlNqK89hXQmtPEWSYPRVnx70MQtA8JX+qV210xMneJhz6qwOKKEqViuUmkrOQSxJLYex5KOoMQ+FpJlSppiJskktIzVXlEOYhqwXhUXZxtRTG48UqZdqdGjm46JVi65alOPxbqhHILYtN0WYfF+JJX0AVpe4ucZcSS7uVxtNHYHAGoRYhp/dFjeLTrdeiwnDKNFpeRnNwC6csxYARa6PgkrO1yS0J6FNrAM4Obl0jwiOczvoFz3YIGsxLp0N9r/kK+KBMy2ZLjINyZ1IFhvtuuaaDa+94k/dHGVoyiZYuYHPRs/wAJVxKu52hytFtZnmT3Rr2k3N4ub2/LhKcQHPMDQaJWeTcaQcUE4cQANbR23n6+qMyk3JbYW0kjbzQQ4XXA8Pi6DXylD/pq2bKWuk7EJSnKGuLNtP2Nv1TGgEkb2Bk+iuzjAi1Mk6ySBZDUOFZR47Ryuf6R9JlNo+Hw2u48tOwVMVke3oF0CV+PVBJFJgjmXa84CzwntISYdSBHNpuI72KIxPGqDbCkHxuQCPLMh2Y2k6SxgaewBU9t5Kjl/bQXroaNrMeJFuiGxFG9roR+IPMqxrmYd8RAI1tNwAOohVuSBOGR9Ow1IHqtnvDhvIADr3LhMEjX06LlN7HSCSD3JkrF9KowzFhuDPrH8pUt9GkeYNvLcRMi646mCLnabbbfndVBtv8AbkpzBH0m2pnyQs8eg4HVaylkmS0mTzm8/wAeSD4piY0SqliC289/9eqG4hiSfNTZ3whaIvwn5rl9SV8YphsRJStz0TgzdcqOdymWSxJRPV4cy1RVwj/CFxdVPRyJLYquFz3xRdWmhxSuluLLVJM0oAlH06SphmI6m1OjEnyTM6eHRVGgtaTVsGo0iOeRmlFsIphQzFu1GSyN1hWYtmFWcJWAJ0ee4nQkFKcNgsxnUBxaQDB+Hw/nRem4gwBpJ0ASc4imDMENzS6CCR4bDMCJm9kzFHdnZ8GTlFhVKqKQiXAZfBbXpBNmyCsq+PDi5rzZxkRZpd05feEudirT8V7tM6DQ9PiSzFVjGv4U2cklbOgo2PWNN4sI8R8589Pkq1WF2aAC1kBxnSTqLwTAKxwTXCm2mCMzpmXBoG+U8tAsg8gGNcpiN+ebrBI8tLkpblrRoHjsSS/IAJM5v2gT9pTHDYOcpLdWgg/5cyet0rwlKahcXAEgzJIzE9R3HovV8Hw7cvipB27CYIGoP+xzK9hvbkZJm9PD2noABYgAdQB1SnG4kNcS219Qc0co9Uy4tVbTbcHObZpNmix00Ebc15itimtkmHOOgBuJ3PaPmmymkrZiRvisSGQ5xDiRMXkGTLTbskuNxL6vxaDQCwGy3ymo4mLk2HlzsEfguFvqBwY1pyxMkN1m0+RUmSM82rpDFURLQbmtuNOoVX0SLhMqvD3A5m2Ik3i0ahaNpZwLXIuL2PL85pC8X+iXfphchW3FndEUMXEnMfrN58tFTFYf880udIMKXNPLhdS2gkkx3h8VNied4vBABHUQPmjqOIIP18+m687RqQm1J3hknxTESBAIJmNdeSs8bNyQMlQVXpCMzIjUjcduiDJhGsqz4haZDo2JuJ6f+pQeLgG2huPPZUuSoFGb9PPz/wBX+SxiddN1A6V0pLpmi2o2CRyWuGfBVsay880O0wuDkj8LK0M7R6bDV/ColVHE2UV8cyohlg2OarlkCuucqAqwWloMouR1FyVU3ouhVRpickRxRKIa1C4R0o2UZzp9kaFs1UYtAFolmjVoFRoWrAsAZ572qxWXIwAEnxGeQ0/leZdWmLAQI73Jk+qZ+07HPxZYNcrco/4z90jaUalSPo/Cgo4Yr7X/ACbmqQIGoMg9fwBVwtPM7M7Rvzd+XVKzxPhPaRB6SicP8Gt50g3mTM+gjqvN2yoNsQAbOBzTM5g4CIbG3c721WOIaSc2g2AOhgNk31gD1V6NMNLgXSC0XbDvERIBM23nqNFvUptMAWAm5Mzy7HQI4Rt2wRZhqM1YE8wQC6GgGZA8l67APbTpZ3nK0CS42EA328oXm+FFn6jK7PdpgtAdeLAg7df9oP2l4gXRSafA3XbMdienJKy5fhY5NGU5Sovxbj5rv/6YjZpdBsOQ5oGnh3akG5N9ATvB31WXDcMXSRMi7SBm8W08hO69dR4c4O97VLGw2XGA1gBBG9vwKbx1LKueR/2+gyTUdIXYHBzHkYO8cvX5po3h8zEgX3+UrBnGKNOG02uqkA5f2tvykTe2y0qYTEYkeNzQIn3bTlgbZm6+qvjNf0i39wXHcQo0xDR713IHK3zd9khw9VzajnVARnuJMAHNzOosWr1dH2bHfTpyn+Uj9paTGkUWmXWc865RBhvfeOgUnlRdc72ul9w4tdGWKaJjp/P9JTiGeJM2Ee7bOoEG0WGnmhvd5pcszr40F9Qo6B20lvlsALamZmdIEbb+q2p0v77BahpaeRG9jzHmvY/H4o82YUqhBtor4skhptppqQCTr6FFVMIWta4kEPBIg3EGDO421j5LHGzDZIMEhschqdNCTPminFpVZid9AzQo4wugLhXukaC4jVDEI2tRMZuaDcuH5NubbCiyB6iqVFPYdD5j1eVgCrgrtqZA0aZlenWuspVJXnMzjY/wuKTKjWleVo1CnWCqKiE7IM+FLY9pLdoQ2GcjWBMOZLTOtat6bVVrVwVYWC+zx/t3Qy1GPAHiEOPVsxHkV5pi9f7btL6bSNGul3mIXlKBAInmJHMTdYtyPpPAleBfY2dQaWF7XAZcoLSfE5xmS0clbLAAve4OluymPNPOTTBDTpJnvC47EFwEx4RAtty67+qdqymN9huAJaQ6AYuA67SRbSb6rVz2hpmQ60BsZS3VwN7XiNVSlUa67Zbka1pBcDmJJkt/N1V7ZBMRlEuPnA0FpkBNj0e/uDYb/wCw1JIhpb3lDGmMwc4xBzTIBkXHzRuGaXZoEhvicRGmgt3J9eiE4jRFxM9oIJ6eUfNJnFcW0gl2dqcZcHuewh9RxJe9zG3LvitEHVDYjiTnuHv6j6nQEQOw+EeQQtXCkIc04K5GXLmWmv8AwZGMfQ1/+cawRRohp0zvPvHdwIgH1QFPFvD/AHge4PNy4OId66rDIo5inllyydt9fsFSGNfiuJqfFXqH/kWjzhVp0/dlubUmTPUWPUIKm10pjWwxgFxBdIDYuIiZlV+Pc7nTte2C9aB6r75R5lNMLRFpBDSQCYJj+4ul1PDGfy6Z4ao6GsLvDMtBgDMYEk/dX+MpW3JAS+xo/Dt0zifHIcC0eEeG+5N7LENMTFp1i3OPoj64aco8Lc1y58fEJBAI0bolrqlumsdeyqlSBReIE6TbnJF/LUIWs6StK9S97mBBGmgj5IV7lNlmgkWLlwXMKgk6LuWFLkzUa3QzqUrc0oxmHi4TDC4mbFdxTQk5IRyxsng5QlTESiIqUbqLmvHIs5IYAqwKzULl0eRJRvKgas2FbhHHYD0daEfhqsIFq1Dk2LoTNWekweIlOMIZXjcBiIdC9XgaohURlaOX5OLixk+wSvGV4RlauIXmuL4i8ArXpCsGPlKivEMWXNLeYIXmG2KbkoLEsBMjzQKe9na8WofKcZhs2hB8JdrEdENTMkA2ki/Ja4xmVxy6WiLoSqYTMk0v2LI7HOCoSKpY4HLBi1xPOeQNxOizrvGU6m21gDI9f7SejXgiTAm6YMrai92xbc639PkixZ4zWjXFo34W9uYhxdEQcoDjBzQI3vCpXdOtyTBOpgfnyWWBdBcBcmALTry5FEClmLogQC65DTDfO7uiZB3Ex6ZSgPe5g4y5v+R1btc77QhMThptpyVqzixzXtmR6EciihjKT7yGndrjoe51SnwlcJ/7QW+0KCADDrHnsVZ1Ec+yYvwBrGWw7nlIt9lSlh2hvw6HUa9o/lJ/DO2qVeme5mdGkTFpdMRBm15RD25j0GgXaJLSHMdBgkkEgtmQWyd4+q2wzd1XCHoEGe2COi0w5AJzNzCHACctyPCfI3VX+J8AjlcwPMoghhLcgcPCM0kOl98xEbLfZ5mWOc4NbABiRoATmEyefRLXMedk04iMoa0ggnxXEW/aRzm/ogqtX6X7pOZJvbYSBwwjVdoYYuMmwW+FMuk6D59Cis4lRTp9MXPI1pFWUABAWNWmi5WdQIJRVCFJ2LXiFo2vNipXCDcVLKTg9FKXJBJaurFldREpwfs2mGEKsLchVypjQlM40LUFUhQIk6BezVpUL1mSqyicjKNhUTfh3EjokjWyV6XhGBZE7p2Dk2T+TwUdhzXucEi4o0hy9SylCXcT4dnVU42tEGHKoz30eaqkwshh3HReip8LGiY0eHtA0U7wNvbKn5cY9HmsLwuo4RtyKZ0fZtp+IJ3TytQeO40GaGU5RjFbE/ics3UTtL2XoAeJgK85xjAjD1HXIaSDSy3kH4hP7SEbU9qXGwCqzD1MSCcxBiW9FkZxb+UqxSyQd5Ho83SqFrpGhsexTZ8EABrWlrYcQT4iJvffsk2Nw7qbi14gj59ua34bxBvhY4RFmuGpvMO+gWYs8Yz4S9nSatWgt1IkOMaAT02CW1sJunIotIkuvsN//wBco1CNZg3M8NQOptcPEcs5m9BvCpyYY5FTMUqFWG4VV917wN8IF7xqToN1ak61wDY6315dUx/RuaHMZWe1juYIkayW9UufiK+VzSacBoaJaM0TPg5FeS4KkjLbOYqoDAgAgBtgB4W843mbqPr5G9do5/wsKVMgFzpNrnrbX1WbjmP8rHN19wkktEoWLS4SJkjmdYPdG06wa4uIgAuMAkRrYHVDteQA2bTmubDa4Up4N1VpANpv5f7QuXCOuwZSS3IAxGOc92ZxJsA2TMNGgHRdw9N1Q9N+ydYT2faLvKvxENa3KwQoOGRq5sU/Ki3xgLa9QCwEALNlRYlSVO57DUVQYKi46ohBUXDUXviGcC1dyCeVq9yxIUuWVsfBUUUXYXEgaeidTVMi3WLiuxJI5ibK5FUhbBVehaCTMlxRxWZJS2w0jRok2XouH5mtEJRw7DEm69PQo5QOSr8eL7IvLyL9Ibh3khX92UC3HtaYlFPxrSNVbRzJQkvRZtJSrVDRqhamLAFiEix9eo462S5zURmPC5vYbjsdMwV5zFOLitnPcTCPwnDyVFJvI6OjBRwqwXA8PnVMsRjTQbAR9LDimJK83x/Gh5geac0sWO/YMJPNPfQsx+LNZxLvJAFkIjKumlK5juTuXZ1YNRVIo3GVAIDvoVvS43iAQTUc8CwDyX23AJuEPUYBzlYkI5TywaqT/kZSZ6E+1Gac1IjYQ8vgDYZlKXF6BJztqRlMZQJz7b6LzsLoamx87OtPZnCJviMQ52p8hoE0wvGvd4c0DTDpuHcvuUvwuHnlpN10tE9EcXkheRvbBlxfZocSXxDYjU/ZOMBXgQk7SNrIijUhejmk5XJk+Zc1Q+dXsl2KuuNrKr3SnSnaJIQ4sBqU0NUKOqoKqFDkRbBmOZVLlxyqpHJlCQVg6GcgL1+F9mm5ZjVeQ4XiMlQHZfUOG1w9gI5LqeDGEoXWzm+dknBquhAPZlnJdXoXuuorfhx+hD+IyfU8E51liXKKLnzZ0YonvFV1RRRLcmMpGbTJher4Xw2mW3EqKKzxEmm2SedJxiqAOKPLKjWsH+k7pVpYAVFE7H+pkuVflxYrxWDkzKwc12xUURyQUJugd+YbqtNrnGAVFFLJboov5bGeGwAFymdBvJRRPhFIgnJy7F3tFjYbAXkHOUUUflSfOjreJFLHo5Ks0qKKayphDYOoVH4Zh2jsoomdoVbT0Z/pG8yuvDYiFFEt66Dtvsyc5Z51FEiUmMSLsctmOUUTIMGSCGvV866oqUxDRm9yGqriiCQcAV4WZUUUMlspRVew9lOLH4CooqvBm45aXsR5cFLG7PUPkqKKLtnBP//Z';
fetch(imageDataUrl).then(res => {
  res.arrayBuffer().then(buf => {
    fileCenas.push(new File([buf], 'image_data_url.jpg', { type: 'image/jpeg' })); 
    fileCenas.push(new File([buf], 'image_data_url.jpg', { type: 'image/jpeg' })); 
    fileCenas.push(new File([buf], 'image_data_url.jpg', { type: 'image/jpeg' })); 
  })
})
const getBase64 =(file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


const useStyles = makeStyles(() => ({
  root: {},
  item: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

const onUnload = (e) => {
  console.log(e);

  // confirmAlert({
  //   title: 'Confirm to submit',
  //   message: 'Are you sure to do this.',
  //   buttons: [
  //     {
  //       label: 'Yes',
  //       onClick: () => alert('Click Yes')
  //     },
  //     {
  //       label: 'No',
  //       onClick: () => alert('Click No')
  //     }
  //   ]
  // });
  e.preventDefault();
  return "unloading";

}
const methods = {


  componentWillUnmount() {
    window.removeEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
  }
};





//#region STYLES
const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const saveAs = (blob, fileName) => {
  if (typeof navigator.msSaveOrOpenBlob !== 'undefined') {
    return navigator.msSaveOrOpenBlob(blob, fileName);
  } else if (typeof navigator.msSaveBlob !== 'undefined') {
    return navigator.msSaveBlob(blob, fileName);
  } else {
    var elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = fileName;
    elem.style = 'display:none;opacity:0;color:transparent;';
    (document.body || document.documentElement).appendChild(elem);
    if (typeof elem.click === 'function') {
      elem.click();
    } else {
      elem.target = '_blank';
      elem.dispatchEvent(new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      }));
    }
    URL.revokeObjectURL(elem.href);
  }
}
const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);




const TableStyles = makeStyles({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
});
//#endregion STYLES


//#region VAR

var TabelaFicheirosDS = [];
var valuesDS = [
  { tipo: '' },
  { nomeEquip: '' },
  { descricao: '' },
  { ficheiros: [] },
  { imagens: [] }
];

var TabelaFicheirosM = [];
var valuesM = [
  { tipo: '' },
  { nomeEquip: '' },
  { descricao: '' },
  { ficheiros: [] },
  { imagens: [] }
];

var valuesSolucao = [
  { imagens: [] }
];

var valuesPub = [
  { imagens: [] }
];

var valuesManutencoes = [
  { ficheiros: [] }
];

var carregaFiles = [];


const BasicConfigurations = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [values, setValues] = useState({
    TextoHome: '',
    TextoSolucao: '',
    tituloPub: '',
    textoPub: '',
    BtnPub: '',
    emailSuporte: 'suporte@maxiglobal.pt',
    emailComercial: 'geral@maxiglobal.pt',
    emailbotao: 'geral@maxiglobal.pt',
    moradaPorto: 'Rua da Urtigueira Nº 562 4410-304 Canelas - VNG - Portugal',
    moradaLisboa: 'Rua Poeta Bocage nº 11D, Comércio 3, 1600-581, Lisboa',
    contactoPorto: '22 905 97 10',
    contactoLisboa: '21 848 5169',
    nomeManutencao: 'Manutenções',
    emailRegisto: '',
    passwordRegisto: '',
    confirmarPassword: '',
    ficheirosDSEditing: [], 
    imagensDSEditing: [],
    ficheirosMEditing: [],
    imagensMEditing: [], 
  });


  //#region HANDLECHANGE


  const handleChange = event => {

    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };


  //validação email de registo
  const handleChangeemailRegisto = event => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });

    $("#resultadoPass").html("");
    var emailRegisto = values.emailRegisto;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

    if (re.test(String(emailRegisto).toLowerCase()) === true) {
      $("#resultadoPass").html("");
    }
    else {
      $("#resultadoPass").html("<p>O Email de registo introduzido não é válido!</p>");
    }
  };

  //validação password
  const handleChangepasswordRegisto = event => {

    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });


    var passwordRegisto = values.passwordRegisto;

    if (scorePassword(passwordRegisto) < 30) {
      $("#resultadoPass").html("<p>A password introduzida é muito fraca</p>");
    }
    else if (scorePassword(passwordRegisto) < 60) {
      $("#resultadoPass").html("<p>A password introduzida é fraca</p>");
    }
    else if (scorePassword(passwordRegisto) > 60) {
      $("#resultadoPass").html("<p>A password introduzida é forte</p>");
    }
    else if (scorePassword(passwordRegisto) > 80) {
      $("#resultadoPass").html("<p>A password introduzida é muito forte</p>");
    }

  };



  const handleChangeFileSolucao = fich => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex.name)
    ));
    valuesSolucao.imagens = newFiles;
  };

  const handleChangeFilePub = fich => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex.name)
    ));
    valuesPub.imagens = newFiles;
  };

  const handleChangeFileManutencoes = fich => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex.name)
    ));
    valuesManutencoes.ficheiros = newFiles;
  };

  const handleChangeEmailPub = event => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    $("#resultadoEmailPub").html("");
    var emailPub = values.BtnPub;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

    if (re.test(String(emailPub).toLowerCase()) === true) {
      $("#resultadoEmailPub").html("");

    }
    else {
      $("#resultadoEmailPub").html("<p>O Email de registo introduzido não é válido!</p>");
    }
  };

  const handleChangeemailSuporte = event => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    $("#resultadoPass").html("");
    var emailSuporte = values.emailSuporte;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

    if (re.test(String(emailSuporte).toLowerCase()) === true) {
      $("#resultadoemailSuporte").html("");
    }
    else {
      $("#resultadoemailSuporte").html("<p>O Email de registo introduzido não é válido!</p>");
    }
  };

  const handleChangeemailComercial = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    $("#resultadoPass").html("");
    var emailComercial = values.emailComercial;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

    if (re.test(String(emailComercial).toLowerCase()) === true) {
      $("#resultadoemailComercial").html("");
    }
    else {
      $("#resultadoemailComercial").html("<p>O Email de registo introduzido não é válido!</p>");
    }
  };

  const handleChangeemailBotao = event => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    $("#resultadoPass").html("");
    var emailBotao = values.emailbotao;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

    if (re.test(String(emailBotao).toLowerCase()) === true) {
      $("#resultadoemailBotao").html("");
    }
    else {
      $("#resultadoemailBotao").html("<p>O Email de registo introduzido não é válido!</p>");
    }
  };

  //#endregion HANDLECHANGE


  //Âncoras menus DS e M
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [anchorE2, setAnchorE2] = React.useState(null);
  const open2 = Boolean(anchorE2);


  //#region DATASHEETS

  //Fecha Menu - DS
  const handleClickDS = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDS = () => {
    setAnchorEl(null);
  }

  //Input changes (files)

  const handleChangeEditDescricao = event => {
    console.log(event);
    descricaoEditing = event.target.value;
  }
  const handleChangeFileDS = fich => {

    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex)
    ));
    valuesDS.ficheiros = newFiles;
  };

  //Input changes (imagens)
  const handleChangeImgDS = fich => {

    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex)
    ));
    valuesDS.imagens = newFiles;
  };



  const editarItemM = () => {
    console.log("edit manual.."); 


    var _tipo = tipoManualEditing; 
    var _nomeEquip =$("#nomeEquipME").val();

    TabelaFicheirosM[idEditing].tipo = _tipo;
    TabelaFicheirosM[idEditing].nomeEquip = _nomeEquip;
    TabelaFicheirosM[idEditing].ficheiros = values.ficheirosMEditing;
    TabelaFicheirosM[idEditing].imagens = values.imagensMEditing; 

    ModalManuaisEditClose();


  }



  //editar item e fecha modal
  const editarItemDS = () => {

    console.log(values.estadoImagensEdit); 
    var _tipo = tipoFichaTecnicaEditing;
    var _nomeEquip = $("#nomeEquipDSE").val();
    var _descricao = $("#descricaoDSE").val();
    console.log("editing");
    console.log(_nomeEquip);
    TabelaFicheirosDS[idEditing].tipo = _tipo;
    TabelaFicheirosDS[idEditing].nomeEquip = _nomeEquip;
    TabelaFicheirosDS[idEditing].descricao = _descricao;
    TabelaFicheirosDS[idEditing].ficheiros = values.ficheirosDSEditing;
    TabelaFicheirosDS[idEditing].imagens = values.imagensDSEditing; 


    values.ficheirosDSEditing = [];
    values.imagensDSEditing= []; 

    ModalFichaTecnicaEditClose();


  }
  //Guarda Item e fecha modal
  const guardarItemDS = () => {

    var _tipo = valuesDS.tipo;
    var _nomeEquip = $("#nomeEquipDS").val();
    var _descricao = $("#descricaoDS").val();
    var _ficheiros = valuesDS.ficheiros;
    var _imagens = valuesDS.imagens;
    console.log(_nomeEquip);

    var newLinha = { tipo: _tipo, nomeEquip: _nomeEquip, descricao: _descricao, ficheiros: _ficheiros, imagens: _imagens };

    TabelaFicheirosDS.push(newLinha);
    valuesDS.ficheiros = [];
    valuesDS.imagens = [];


    ModalhandleCloseDS();
  }



    // modal edit - fichas tecnicas 
    const [ModalOpenManuaisEdit, ModalSetOpenManuaisEdit] = React.useState(false);
    //Open Modal
    const ModalManuaisEditOpen = () => {
      ModalSetOpenManuaisEdit(true);
    };
    //Close Modal
    const ModalManuaisEditClose = () => {
      ModalSetOpenManuaisEdit(false);
    };

    
  // modal edit - fichas tecnicas 
  const [ModalOpenEdit, ModalSetOpenEdit] = React.useState(false);
  //Open Modal
  const ModalFichaTecnicaEditOpen = () => {
    ModalSetOpenEdit(true);
  };
  //Close Modal
  const ModalFichaTecnicaEditClose = () => {
    ModalSetOpenEdit(false);
  };



  //click M DIALOG
  const [ModalOpenM, ModalSetOpenM] = React.useState(false);

  //Open Modal
  const ModalHandleOpenM = () => {
    ModalSetOpenM(true);
  };
  //Close Modal
  const ModalHandleCloseM = () => {
    ModalSetOpenM(false);
  };

  //Click DS Dialog
  const [ModalopenDS, ModalsetOpenDS] = React.useState(false);

  //Open Modal
  const ModalhandleOpenDS = () => {
    ModalsetOpenDS(true);
  };
  //Close Modal
  const ModalhandleCloseDS = () => {
    ModalsetOpenDS(false);
  };

  //Select Equip Type
  const abreDSColling = () => {

    valuesDS.tipo = 'cooling';
    ModalhandleOpenDS();
    setAnchorEl(null);
  };
  const abreDSSecurity = () => {

    valuesDS.tipo = 'security';
    ModalhandleOpenDS();
    setAnchorEl(null);
  };
  const abreDSPower = () => {
    valuesDS.tipo = 'power';
    ModalhandleOpenDS();
    setAnchorEl(null);
  };
  const abreDSMonitoring = () => {
    valuesDS.tipo = 'monitoring';
    ModalhandleOpenDS();
    setAnchorEl(null);
  };
  const abreDSDatacenter = () => {
    valuesDS.tipo = 'datacenter';
    ModalhandleOpenDS();
    setAnchorEl(null);
  };
  const abreDSNetworking = () => {
    valuesDS.tipo = 'networking';
    ModalhandleOpenDS();
    setAnchorEl(null);
  };




  //#endregion DATASHEETS


  //#region MANUALS

  //Fecha Menu - M
  const handleClickM = event => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setAnchorE2(event.currentTarget);
  };

  const handleCloseM = () => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    setAnchorE2(null);
  }

  //Input changes (files)
  const handleChangeFileM = fich => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });

    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex)
    ));
    valuesM.ficheiros = newFiles;
  };

  //Input changes (imagens)
  const handleChangeImgM = fich => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return ev.returnValue = 'Possui Alterações não guardadas!';
    });
    let newFiles = [];
    fich.map((filex, index) => (
      carregaFiles.push(filex),
      newFiles.push(filex)
    ));
    valuesM.imagens = newFiles;
  };

  const handleDeleteCurrentInfoFichasTecnicas = (index) => {

    confirmAlert({
      title: 'Remover Ficha?',
      message: 'Ficha Técnica : ' + TabelaFicheirosDS[index].nomeEquip + ' ?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => { TabelaFicheirosDS.splice(index, 1); ModalhandleOpenDS() }
        },
        {
          label: 'Não',

        }
      ]
    });
  }


  const handleOpenModalWithInfoManuais = (index) => {
    var currentManual = TabelaFicheirosM[index];

    ModalSetNomeManualEditing(currentManual.nomeEquip);
    ModalSetFicheiros(currentManual.ficheiros);
    ModalSetImagens(currentManual.imagens);
    nomeEquipEditing = currentManual.nomeEquip;
    idEditing = index;

    tipoManualEditing = currentManual.tipo;
    let processedFiles = 0; 
    var filesMEditing = TabelaFicheirosM[idEditing].ficheiros; 
    var imagensMEditing = TabelaFicheirosM[idEditing].imagens; 
    values.ficheirosMEditing=[]; 
    values.imagensMEditing = []; 
    for (var i=0; i<filesMEditing.length; i++)  {
      console.log(filesMEditing[i]); 
      var fileName = filesMEditing[i].name; 
    values.ficheirosMEditing.push(filesMEditing[i]); 
    }
    for (var i=0; i<imagensMEditing.length; i++) {
      values.imagensMEditing.push(imagensMEditing[i]); 
    }  
      console.log("ficheiros editing for modal :");
      console.log(values.ficheirosDSEditing); 
      
     
      console.log(index);
    ModalManuaisEditOpen(); 
  }

  const handleDeleteCurrentInfoManuais = (index) => {

    confirmAlert({
      title: 'Remover Manual?',
      message: 'Manual : ' + TabelaFicheirosM[index].nomeEquip + ' ?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => { TabelaFicheirosM.splice(index, 1); ModalhandleOpenM() }
        },
        {
          label: 'Não',

        }
      ]
    });


  }

  const  handleOpenModalWithInfoFichasTecnicas = (index) => {

    // set info from modal 
    var currentFichaTecnica = TabelaFicheirosDS[index];
    descricaoEditing = currentFichaTecnica.descricao;
    ModalSetDescricaoEditing(currentFichaTecnica.descricao);
    ModalSetNomeEditing(currentFichaTecnica.nomeEquip);
    ModalSetFicheiros(currentFichaTecnica.ficheiros);
    ModalSetImagens(currentFichaTecnica.imagens);
    nomeEquipEditing = currentFichaTecnica.nomeEquip;
    idEditing = index;

    tipoFichaTecnicaEditing = currentFichaTecnica.tipo;
    let processedFiles = 0; 
    var filesDSEditing = TabelaFicheirosDS[idEditing].ficheiros; 
    var imagensDSEditing = TabelaFicheirosDS[idEditing].imagens; 
    values.ficheirosDSEditing=[]; 
    values.imagensDSEditing = []; 
    for (var i=0; i<filesDSEditing.length; i++)  {
      console.log(filesDSEditing[i]); 
      var fileName = filesDSEditing[i].name; 
    values.ficheirosDSEditing.push(filesDSEditing[i]); 
    }
    for (var i=0; i<imagensDSEditing.length; i++) {
      values.imagensDSEditing.push(imagensDSEditing[i]); 
    }  
     
      console.log(values.ficheirosDSEditing); 
      
      ModalFichaTecnicaEditOpen();
      console.log(index);
    

  }

  //Guarda Item e fecha modal
  const guardarItemM = () => {

    var _tipo = valuesM.tipo;
    var _nomeEquip = $("#nomeEquipM").val();
    var _ficheiros = valuesM.ficheiros;
    var _imagens = valuesM.imagens;

    var newLinha = { tipo: _tipo, nomeEquip: _nomeEquip, ficheiros: _ficheiros, imagens: _imagens };

    TabelaFicheirosM.push(newLinha);
    valuesM.ficheiros = [];
    valuesM.imagens = [];


    ModalhandleCloseM();
  }

  // ------------------------ FICHAS TECNICAS EDIT --------------------------------

  const ModalSetFicheiros = (files) => {

    values.estadoFicheirosEdit= files; 


  };

  const ModalSetImagens = (imagens) => {
   values.estadoImagensEdit = imagens; 

  };

  //estado nome 

  const [estadoNomeEditManual, ModalSetNomeManuaisEdit] = React.useState('');
  const ModalSetNomeManualChange = (event) => {
    ModalSetNomeManuaisEdit(event.target.value);
  };
  const ModalSetNomeManualEditing = (descricao) => {
    ModalSetNomeManuaisEdit(descricao);
  };

  const [estadoNomeEdit, ModalSetNomeEdit] = React.useState('');
  const ModalSetNomeChange = (event) => {
    ModalSetNomeEdit(event.target.value);
  };
  const ModalSetNomeEditing = (descricao) => {
    ModalSetNomeEdit(descricao);
  };

  //estado descricao 
  const [estadoDescricaoEdit, ModalSetDescricaoEdit] = React.useState('');
  const ModalSetDescricaoChange = (event) => {
    ModalSetDescricaoEdit(event.target.value);
  };
  const ModalSetDescricaoEditing = (descricao) => {
    ModalSetDescricaoEdit(descricao);
  };

  // ------------------------ FICHAS TECNICAS EDIT ENDING--------------------------------

  //Click DS Dialog
  const [ModalopenM, ModalsetOpenM] = React.useState(false);

  //Open Modal
  const ModalhandleOpenM = () => {
    ModalsetOpenM(true);
  };
  //Close Modal
  const ModalhandleCloseM = () => {
    ModalsetOpenM(false);
  };

  const handleSubmit = (files, allFiles) => {

    
    ficheirosDSEditing.forEach(f => f.remove())
  }


  //Select Equip Type
  const abreMColling = () => {
    valuesM.tipo = 'cooling';
    ModalhandleOpenM();
    setAnchorE2(null);
  };
  const abreMSecurity = () => {
    valuesM.tipo = 'security';
    ModalhandleOpenM();
    setAnchorE2(null);
  };
  const abreMPower = () => {
    valuesM.tipo = 'power';
    ModalhandleOpenM();
    setAnchorE2(null);
  };

  const abreMMonitoring = () => {
    valuesM.tipo = 'monitoring';
    ModalhandleOpenM();
    setAnchorE2(null);
  };
  const abreMDatacenter = () => {
    valuesM.tipo = 'datacenter';
    ModalhandleOpenM();
    setAnchorE2(null);
  };
  const abreMNetworking = () => {
    valuesM.tipo = 'networking';
    ModalhandleOpenM();
    setAnchorE2(null);
  };

  //#endregion MANUALS

  const ImagensMEditingSet = ({ file }, status) => {
 
  
    if (status=="removed") {

      for (var i=0; i<values.imagensMEditing.length; i++) {
        if (values.imagensMEditing[i].name == file.name) {
          values.imagensMEditing.splice(i,1); 
        }
      }
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
          carregaFiles.splice(i,1); 
        }
      }

    } 
    if (status== "done") {

      var arrayContainsFile = 0; 
      for (var i=0 ; i<values.imagensMEditing.length; i++) {
        if (values.imagensMEditing[i].name == file.name) {
          arrayContainsFile++; 
        }
      }
  

      if (arrayContainsFile==0) {
        console.log("adding imagem to array"); 
        values.imagensMEditing.push(file); 
      }

      var arrayContainsFileCarregafile=0;
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
         arrayContainsFileCarregafile++; 
        }
      }
    if (arrayContainsFileCarregafile==0) {
        carregaFiles.push(file); 
      }

    }
    console.log(values.imagensMEditing); 
  }
  const FicheirosMEditingSet = ({file }, status)=> {

  
    if (status=="removed") {

      for (var i=0; i<values.ficheirosMEditing.length; i++) {
        if (values.ficheirosMEditing[i].name == file.name) {
          values.ficheirosMEditing.splice(i,1); 
        }
      }
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
          carregaFiles.splice(i,1); 
        }
      }
    } 
    if (status== "done") {

      var arrayContainsFile = 0; 
      for (var i=0 ; i<values.ficheirosMEditing.length; i++) {
        if (values.ficheirosMEditing[i].name == file.name) {
          arrayContainsFile++; 
        }
      }
      if (arrayContainsFile==0) {
        console.log("adding ficheiro to array"); 
        values.ficheirosMEditing.push(file); 
      }
      var arrayContainsFileCarregafile=0;
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
         arrayContainsFileCarregafile++; 
        }
      }
      if (arrayContainsFileCarregafile==0) {
        carregaFiles.push(file); 
      }
      
    }
  }

  const FicheirosDSEditingSet = ({file }, status)=> {

  
    if (status=="removed") {

      for (var i=0; i<values.ficheirosDSEditing.length; i++) {
        if (values.ficheirosDSEditing[i].name == file.name) {
          values.ficheirosDSEditing.splice(i,1); 
        }
      }
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
          carregaFiles.splice(i,1); 
        }
      }
    } 
    if (status== "done") {

      var arrayContainsFile = 0; 
      for (var i=0 ; i<values.ficheirosDSEditing.length; i++) {
        if (values.ficheirosDSEditing[i].name == file.name) {
          arrayContainsFile++; 
        }
      }
      var arrayContainsFileCarregafile=0;
          for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
         arrayContainsFileCarregafile++; 
        }
      }
      if (arrayContainsFile==0) {
        console.log("adding ficheiro to array"); 
        values.ficheirosDSEditing.push(file); 
      }
      if (arrayContainsFileCarregafile==0) {
        carregaFiles.push(file); 
      }

      
    }
  }

  const ImagensDSEditingSet = ({ file }, status) => {
 
  
    if (status=="removed") {

      for (var i=0; i<values.imagensDSEditing.length; i++) {
        if (values.imagensDSEditing[i].name == file.name) {
          values.imagensDSEditing.splice(i,1); 
        }
      }
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
          carregaFiles.splice(i,1); 
        }
      }
    } 
    if (status== "done") {

      var arrayContainsFile = 0; 
      for (var i=0 ; i<values.imagensDSEditing.length; i++) {
        if (values.imagensDSEditing[i].name == file.name) {
          arrayContainsFile++; 
        }
      }
      if (arrayContainsFile==0) {
        console.log("adding imagem to array"); 
        values.imagensDSEditing.push(file); 
      }
      var arrayContainsFileCarregafile=0;
      for (var i=0; i<carregaFiles.length; i++) {
        if (carregaFiles[i].name == file.name) {
         arrayContainsFileCarregafile++; 
        }
      }
      if (arrayContainsFileCarregafile==0) {
        carregaFiles.push(file); 
      }
    }
    console.log(values.imagensDSEditing); 
  }

  //score password funçao
  //ISO 27001 -> 80-strong; 60 - good , 30 - week , validar >60
  const scorePassword = (pass) => {
    var score = 0;
    if (!pass)
      return score;

    var letters = new Object();
    for (var i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
    }

    var variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass),
    }

    var variationCount = 0;
    for (var check in variations) {
      variationCount += (variations[check] == true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    return parseInt(score);
  }


  //#region DADOS FINAIS

  const finalizarDossier = () => {
    //finalizar dossier
    $("#resultadoPass").html("");

    /* Ir buscar dados */

    var TextoHome = values.TextoHome;
    var imagemSolucao = valuesSolucao.imagens;
    var textoSolucao = values.textoSolucao;
    var tituloPub = values.tituloPub;
    var textoPub = values.textoPub;
    var imagemPub = valuesPub.imagens;
    var BtnPub = values.BtnPub;

    // Fichas Técnicas
    var DadosFicheirosDS = TabelaFicheirosDS;

    // Manuais
    var DadosFicheirosM = TabelaFicheirosM;

    // Assistência
    var emailSuporte = values.emailSuporte;
    var emailComercial = values.emailComercial;
    var emailbotao = values.emailbotao;
    var moradaPorto = values.moradaPorto;
    var moradaLisboa = values.moradaLisboa;
    var contactoPorto = values.contactoPorto;
    var contactoLisboa = values.contactoLisboa;

    // Manutencões
    var ficheirosManutencao = valuesManutencoes.ficheiros;
    var nomeManutencao = values.nomeManutencao;


    // Dados Utilizador
    var emailRegisto = values.emailRegisto;
    
    var passwordRegisto = values.passwordRegisto;
    var confirmarPassword = values.confirmarPassword;
    var idDossier = 0;



    //Criar utilizador

    if (emailRegisto == "") {
      alert("Por favor inserir Email associado a Dossier!");
      return; 
    }
    if (passwordRegisto == "" || confirmarPassword == "") {
      alert("Por favor verificar passwords!");
      return; 
    }
    if (scorePassword(passwordRegisto) <= 60) {
      $("#resultadoPass").html("<p class='alert alert-danger text-center mt-2'>A password introduzida é fraca</p>");
      return;
    }
    else if (passwordRegisto != confirmarPassword) {
      $("#resultadoPass").html("<p class='alert alert-danger text-center mt-2'>As passwords introduzidas não coincidem!</p>");
      alert("Passwords não coincidem!")
      return; 
    }
    else {

      var hashPassword = sha512(passwordRegisto);


      var xml1 = "";
      var xml2 = "";
      var xml3 = "";
      var xml4 = "";
      var xml5 = "";
      var xml6 = "";
      var xml7 = "";

      // Gera String XML
      xml1 = (
        '<?xml version="1.0" encoding="UTF-8"?>' +
        '<Dossier>' + 
        '<Utilizador>' +  emailRegisto + '</Utilizador>' +
        '<Password>' + hashPassword + '</Password>' +
        '<Home>' +
        '<TextoHome>' + TextoHome + '</TextoHome>' +
        '</Home>' +
        '<Solucao>');

      if (imagemSolucao != null) {
        xml1 = (xml1 + imagemSolucao.map((img, index) => (
          '<imagem>' + img + '</imagem>')));
      }

      xml1 = xml1 + '<textoSolucao>' + textoSolucao + '</textoSolucao>' +
        '</Solucao>' +
        '<PublicidadeSide>' +
        '<tituloPub>' + tituloPub + '</tituloPub>' +
        '<textoPub>' + textoPub + '</textoPub>' +
        '<imagemPub>' + imagemPub + '</imagemPub>' +
        '<BtnPub>' + BtnPub + '</BtnPub>' +
        '</PublicidadeSide>' +
        '<FichasTecnicas>';

      if (DadosFicheirosDS != null) {
        xml2 = (
          DadosFicheirosDS.map((obj, index) => (
            '<FichasTecnica categoria="' + obj.tipo + '">' +
            '<Equipamento>' +
            '<nome>' + obj.nomeEquip + '</nome>' +
            '<Ficha>' +
            '<descricao>' + obj.descricao + '</descricao>' +
            obj.ficheiros.map((ficheirox, index) => '<ficheiro name= "' + ficheirox.name + '">' + ficheirox.name + '</ficheiro>') +
            obj.imagens.map((imagemx, index) => '<imagem>' + imagemx.name + '</imagem>') +
            '</Ficha>' +
            '</Equipamento>' +
            '</FichasTecnica>'
          ))
        )
      };


      xml3 = (
        '</FichasTecnicas>' +
        '<Manuais>');



      if (DadosFicheirosM != null) {
        xml4 = (
          DadosFicheirosM.map((obj, index) => (
            '<Manual categoria="' + obj.tipo + '">' +
            '<Equipamento>' +
            '<nome>' + obj.nomeEquip + '</nome>' +
            '<Ficha>' +
            obj.ficheiros.map((ficheirox, index) => '<ficheiro name= "' + ficheirox.name + '">' + ficheirox.name + '</ficheiro>') +
            obj.imagens.map((imagemx, index) => '<imagem>' + imagemx.name + '</imagem>') +
            '</Ficha>' +
            '</Equipamento>' +
            '</Manual>'
          ))
        )
      };

      xml5 = (
        '</Manuais>' +
        '<Assistencia>' +
        '<emails>' +
        '<emailSuporte>' + emailSuporte + '</emailSuporte>' +
        '<emailComercial>' + emailComercial + '</emailComercial>' +
        '<emailbotao>' + emailbotao + '</emailbotao>' +
        '</emails>' +
        '<moradas>' +
        '<moradaPorto>' + moradaPorto + '</moradaPorto>' +
        '<moradaLisboa>' + moradaLisboa + '</moradaLisboa>' +
        '</moradas>' +
        '<contactos>' +
        '<contactoPorto>' + contactoPorto + '</contactoPorto>' +
        '<contactoLisboa>' + contactoLisboa + '</contactoLisboa>' +
        '</contactos>' +
        '</Assistencia>' +
        '<Manutencoes>'
      );


      if (ficheirosManutencao != null) {
        xml6 = (
          '<Manutencao>' +
          ficheirosManutencao.map((ficheirox, index) => (
            '<ficheiro name= "' + ficheirox.name + '">' + ficheirox + '</ficheiro>'))
          +
          '<nomeManutencao>' + nomeManutencao + '</nomeManutencao>' +
          '</Manutencao>'
        )
      }

      xml7 = (

        '</Manutencoes>' +
        '</Dossier>');

      var fixheiroxml = xml1 + xml2 + xml3 + xml4 + xml5 + xml6 + xml7;




      //create zip file to download
      var zip = new JSZip();


      //Envia Ficheiros para a API criar zip
      var xmlFinal = fixheiroxml.replace(/,/g, '');
      console.log('final:', xmlFinal);
      var ficheirosFinal = carregaFiles;

      var filename = "dossier.xml";

      var textoFinal = new Blob([xmlFinal], { type: 'text/plain' });
      var idFinal = idDossier;
      zip.file(filename, textoFinal, { base64: true });
      var assets = zip.folder("assets");
      for (let i = 0; i < ficheirosFinal.length; i++) {
        const file = ficheirosFinal[i];

        assets.file(file.name, file, { base64: true });
      };

      //download zip 
      zip.generateAsync({ type: "blob" })
        .then(function (content) {
          // Force down of the Zip file
          saveAs(content, "Dossier.zip");
        });
  
  }
}

  //apenas guardar
  const guardarDadosTotais = () => {
    $("#resultadoPass").html("");

    /* Ir buscar dados */

    var TextoHome = values.TextoHome;
    var imagemSolucao = valuesSolucao.imagens;
    var textoSolucao = values.textoSolucao;
    var tituloPub = values.tituloPub;
    var textoPub = values.textoPub;
    var imagemPub = valuesPub.imagens;
    var BtnPub = values.BtnPub;

    // Fichas Técnicas
    var DadosFicheirosDS = TabelaFicheirosDS;

    // Manuais
    var DadosFicheirosM = TabelaFicheirosM;

    // Assistência
    var emailSuporte = values.emailSuporte;
    var emailComercial = values.emailComercial;
    var emailbotao = values.emailbotao;
    var moradaPorto = values.moradaPorto;
    var moradaLisboa = values.moradaLisboa;
    var contactoPorto = values.contactoPorto;
    var contactoLisboa = values.contactoLisboa;

    // Manutencões
    var ficheirosManutencao = valuesManutencoes.ficheiros;
    var nomeManutencao = values.nomeManutencao;


    // Dados Utilizador
    var emailRegisto = values.emailRegisto;
    var passwordRegisto = values.passwordRegisto;
    var confirmarPassword = values.confirmarPassword;
    var idDossier = 0;



    //Criar utilizador


   

      var hashPassword = sha512(passwordRegisto);


      var xml1 = "";
      var xml2 = "";
      var xml3 = "";
      var xml4 = "";
      var xml5 = "";
      var xml6 = "";
      var xml7 = "";

      // Gera String XML
      xml1 = (
        '<?xml version="1.0" encoding="UTF-8"?>' +
        '<Dossier>' +
        '<Utilizador></Utilizador>' +
        '<Password></Password>' +
        '<Home>' +
        '<TextoHome>' + TextoHome + '</TextoHome>' +
        '</Home>' +
        '<Solucao>');

      if (imagemSolucao != null) {
        xml1 = (xml1 + imagemSolucao.map((img, index) => (
          '<imagem>' + img + '</imagem>')));
      }

      xml1 = xml1 + '<textoSolucao>' + textoSolucao + '</textoSolucao>' +
        '</Solucao>' +
        '<PublicidadeSide>' +
        '<tituloPub>' + tituloPub + '</tituloPub>' +
        '<textoPub>' + textoPub + '</textoPub>' +
        '<imagemPub>' + imagemPub + '</imagemPub>' +
        '<BtnPub>' + BtnPub + '</BtnPub>' +
        '</PublicidadeSide>' +
        '<FichasTecnicas>';

      if (DadosFicheirosDS != null) {
        xml2 = (
          DadosFicheirosDS.map((obj, index) => (
            '<FichasTecnica categoria="' + obj.tipo + '">' +
            '<Equipamento>' +
            '<nome>' + obj.nomeEquip + '</nome>' +
            '<Ficha>' +
            '<descricao>' + obj.descricao + '</descricao>' +
            obj.ficheiros.map((ficheirox, index) => '<ficheiro name= "' + ficheirox.name + '">' + ficheirox.name + '</ficheiro>') +
            obj.imagens.map((imagemx, index) => '<imagem>' + imagemx.name + '</imagem>') +
            '</Ficha>' +
            '</Equipamento>' +
            '</FichasTecnica>'
          ))
        )
      };


      xml3 = (
        '</FichasTecnicas>' +
        '<Manuais>');



      if (DadosFicheirosM != null) {
        xml4 = (
          DadosFicheirosM.map((obj, index) => (
            '<Manual categoria="' + obj.tipo + '">' +
            '<Equipamento>' +
            '<nome>' + obj.nomeEquip + '</nome>' +
            '<Ficha>' +
            obj.ficheiros.map((ficheirox, index) => '<ficheiro name= "' + ficheirox.name + '">' + ficheirox.name + '</ficheiro>') +
            obj.imagens.map((imagemx, index) => '<imagem>' + imagemx.name + '</imagem>') +
            '</Ficha>' +
            '</Equipamento>' +
            '</Manual>'
          ))
        )
      };

      xml5 = (
        '</Manuais>' +
        '<Assistencia>' +
        '<emails>' +
        '<emailSuporte>' + emailSuporte + '</emailSuporte>' +
        '<emailComercial>' + emailComercial + '</emailComercial>' +
        '<emailbotao>' + emailbotao + '</emailbotao>' +
        '</emails>' +
        '<moradas>' +
        '<moradaPorto>' + moradaPorto + '</moradaPorto>' +
        '<moradaLisboa>' + moradaLisboa + '</moradaLisboa>' +
        '</moradas>' +
        '<contactos>' +
        '<contactoPorto>' + contactoPorto + '</contactoPorto>' +
        '<contactoLisboa>' + contactoLisboa + '</contactoLisboa>' +
        '</contactos>' +
        '</Assistencia>' +
        '<Manutencoes>'
      );


      if (ficheirosManutencao != null) {
        xml6 = (
          '<Manutencao>' +
          ficheirosManutencao.map((ficheirox, index) => (
            '<ficheiro name= "' + ficheirox.name + '">' + ficheirox + '</ficheiro>'))
          +
          '<nomeManutencao>' + nomeManutencao + '</nomeManutencao>' +
          '</Manutencao>'
        )
      }

      xml7 = (

        '</Manutencoes>' +
        '</Dossier>');

      var fixheiroxml = xml1 + xml2 + xml3 + xml4 + xml5 + xml6 + xml7;




      //create zip file to download
      var zip = new JSZip();


      //Envia Ficheiros para a API criar zip
      var xmlFinal = fixheiroxml.replace(/,/g, '');
      console.log('final:', xmlFinal);
      var ficheirosFinal = carregaFiles;

      var filename = "dossier.xml";

      var textoFinal = new Blob([xmlFinal], { type: 'text/plain' });
      var idFinal = idDossier;
      zip.file(filename, textoFinal, { base64: true });
      var assets = zip.folder("assets");
      for (let i = 0; i < ficheirosFinal.length; i++) {
        const file = ficheirosFinal[i];

        assets.file(file.name, file, { base64: true });
      };

      //download zip 
      zip.generateAsync({ type: "blob" })
        .then(function (content) {
          // Force down of the Zip file
          saveAs(content, "Dossier.zip");
        });
    }
  



  //#endregion DADOS FINAIS

  return (

    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <input type="file" id="input" style={{ visibility: 'hidden' }} />

      <form>
        <CardHeader
          title="Configurações de Dossier"
        />
        <Divider />


        <CardContent>
          <CardContent>
            <CardHeader
              subheader="Home"
            />
            <TextField
              fullWidth
              label="Texto de Boas-Vindas"
              name="TextoHome"
              rows={5}
              rowsMax={10}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.TextoHome}
              variant="outlined"
            />
          </CardContent>
        </CardContent>
        <Divider />



        <CardContent>
          <CardContent>
            <CardHeader
              subheader="Publicidade Lateral"
            />
            <TextField
              fullWidth
              label="Título Publicidade"
              name="tituloPub"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.tituloPub}
              variant="outlined"
            />
          </CardContent>
          <CardContent>
            <TextField
              fullWidth
              label="Texto Publicidade"
              name="textoPub"
              rows={40}
              rowsMax={4}
              inputProps={{ maxLength: 85 }}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.textoPub}
              variant="outlined"
            />
          </CardContent>
          <CardContent>
            <DropzoneArea
              showFileNames={true}
              onChange={handleChangeFilePub}
              dropzoneText="Clicar ou largar Imagem"
              acceptedFiles={[".jpg,.png"]}
              maxFileSize={5000000000}
              filesLimit={1}
              id="filesPub"
            />
          </CardContent>
          <CardContent>
            <TextField
              id=""
              fullWidth
              label="Email Botão Publicidade"
              name="BtnPub"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChangeEmailPub}
              type="text"
              value={values.BtnPub}
              variant="outlined"
            />
            <div id="resultadoEmailPub"></div>
          </CardContent>
        </CardContent>
        <Divider />



        <CardContent>
          <CardHeader
            subheader="Solução"
          />
          <CardContent>
            <DropzoneArea
              showFileNames={true}
              maxFileSize={5000000000}
              onChange={handleChangeFileSolucao}
              dropzoneText="Clicar ou largar Imagens"
              acceptedFiles={[".jpg,.png"]}
     
              filesLimit={6}
              id="filesSolucao"
            />
          </CardContent>
          <CardContent>
            <TextField
              fullWidth
              label="Texto da Solução"
              name="textoSolucao"
              rows={40}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.textoSolucao}
              variant="outlined"
            />
          </CardContent>
        </CardContent>
        <Divider />



        {/* #region DATASHEETS  */}
        <CardContent>
          <CardContent>
            <CardHeader
              subheader="Fichas Técnicas"
              action={
                <IconButton
                  aria-label="opções"
                  onClick={handleClickDS}>
                  <MoreVertIcon />
                </IconButton>
              } />
            <Menu
              id="long-menu-DS"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleCloseDS}>
              <MenuItem key="DSCooling" onClick={abreDSColling}>cooling</MenuItem>
              <MenuItem key="DSSecurity" onClick={abreDSSecurity}>security</MenuItem>
              <MenuItem key="DSPower" onClick={abreDSPower}>power</MenuItem>
              <MenuItem key="DSMonitoring" onClick={abreDSMonitoring}>monitoring</MenuItem>
              <MenuItem key="DSDatacenter" onClick={abreDSDatacenter}>datacenter</MenuItem>
              <MenuItem key="DSNetworking" onClick={abreDSNetworking}>networking</MenuItem>
            </Menu>
            <Dialog
              fullWidth="500"
              disableBackdropClick
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={ModalopenDS}
              onClose={ModalhandleCloseDS}>
              <DialogTitle id="tipoDS">{valuesDS.tipo}</DialogTitle>

              <DialogContent dividers>
                <CardContent>

                  <TextField
                    fullWidth
                    id="nomeEquipDS"
                    label="Nome do equipamento"
                    name="nomeEquipDS"
                    rows={1}
                    rowsMax={4}
                    multiline={true}
                    type="text"
                    variant="outlined" />
                </CardContent>
                <CardContent>
                  <TextField
                    fullWidth
                    id="descricaoDS"
                    label="Descrição"
                    name="descricaoDS"
                    rows={10}
                    rowsMax={4}
                    multiline={true}
                    type="text"
                    variant="outlined" />
                </CardContent>
                <CardContent>
                  <DropzoneArea
                    showFileNames={true}
                    id="ficheiros"
                    onChange={handleChangeFileDS}
                    dropzoneText="Clicar ou largar Ficheiros"
                    acceptedFiles={[".pdf"]}
                    maxFileSize={5000000000}
                    filesLimit={6}
                  />
                </CardContent>
                <CardContent>
                  <DropzoneArea
                    showFileNames={true}
                    maxFileSize={5000000000}
                    id="imagens"
                    onChange={handleChangeImgDS}
                    dropzoneText="Clicar ou largar Imagem"
                    acceptedFiles={[".jpg,.png"]}
             
                    filesLimit={6}
                  />
                </CardContent>
              </DialogContent>
              <DialogActions>
              <Button onClick={ModalhandleCloseDS} color="primary">
                  Cancelar
                  
          </Button>
                <Button onClick={guardarItemDS} color="primary">
                  Guardar
                  
          </Button>
         
              </DialogActions>
            </Dialog>
          </CardContent>
        </CardContent>


        {/* ---------------------------- EDIT MODAL FICHAS TECNICAS START ----------------------------- */}

        <Dialog
          fullWidth="500"
          disableBackdropClick
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={ModalOpenEdit}
          onClose={ModalFichaTecnicaEditClose}>
               <DialogTitle id="tipoDSE">Ficha Técnica</DialogTitle>
          <DialogTitle id="tipoDSE">{tipoFichaTecnicaEditing}</DialogTitle>

          <DialogContent dividers>
            <CardContent>

              <TextField
                fullWidth
                id="nomeEquipDSE"
                label="Nome do equipamento"
                name="nomeEquipDSE"
                rows={1}
                value={estadoNomeEdit}
                onChange={ModalSetNomeChange}
                rowsMax={4}
                multiline={true}
                type="text"
                variant="outlined" />
            </CardContent>
            <CardContent>
              <TextField
                fullWidth
                id="descricaoDSE"
                label="Descrição"
                value={estadoDescricaoEdit}
                onChange={ModalSetDescricaoChange}
                name="descricaoDSE"
                rows={10}
                rowsMax={4}
                multiline={true}
                type="text"
                variant="outlined" />
            </CardContent>
            <CardContent>
              <Dropzone
                inputContent="Fichas Técnicas"
                submitButtonDisabled={false}
                onChangeStatus={FicheirosDSEditingSet}
                accept=".pdf"
                initialFiles={values.ficheirosDSEditing}
              />
            </CardContent>
            <CardContent>
            <Dropzone
               id="imagens"
                inputContent="Imagens"
                submitButtonDisabled={false}
                accept="image/*"
                onChangeStatus={ImagensDSEditingSet}
                initialFiles={values.imagensDSEditing}
              
              />
           
            </CardContent>
          </DialogContent>
          <DialogActions>
          <Button onClick={ModalFichaTecnicaEditClose} color="primary">
              Cancelar
          </Button>
            <Button onClick={editarItemDS} color="primary">
              Editar
          </Button>
          </DialogActions>
        </Dialog>

        {/* ---------------------------- EDIT MODAL FICHAS TECNICAS END ----------------------------- */}



  {/* ---------------------------- EDIT MODAL MANUAIS START ----------------------------- */}

  <Dialog
          fullWidth="500"
          disableBackdropClick
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={ModalOpenManuaisEdit}
          onClose={ModalManuaisEditClose}>
                   <DialogTitle id="tipoDSE">Manual</DialogTitle>
          <DialogTitle id="tipoDSE">{tipoFichaTecnicaEditing}</DialogTitle>

          <DialogContent dividers>
            <CardContent>

              <TextField
                fullWidth
                id="nomeEquipME"
                label="Nome do equipamento"
                name="nomeEquipME"
                rows={1}
                value={estadoNomeEditManual}
                onChange={ModalSetNomeManualChange}
                rowsMax={4}
                multiline={true}
                type="text"
                variant="outlined" />
            </CardContent>
         
            <CardContent>
              <Dropzone
                inputContent="Fichas Técnicas"
                submitButtonDisabled={false}
                onChangeStatus={FicheirosMEditingSet}
                accept=".pdf"
                initialFiles={values.ficheirosMEditing}
              />
            </CardContent>
            <CardContent>
            <Dropzone
               id="imagens"
                inputContent="Imagens"
                submitButtonDisabled={false}
                accept="image/*"
                onChangeStatus={ImagensMEditingSet}
                initialFiles={values.imagensMEditing}
              
              />
           
            </CardContent>
          </DialogContent>
          <DialogActions>
          <Button onClick={ModalManuaisEditClose} color="primary">
              Cancelar
          </Button>
            <Button onClick={editarItemM} color="primary">
              Editar
          </Button>
          </DialogActions>
        </Dialog>

        {/* ---------------------------- EDIT MODAL MANUAIS END ----------------------------- */}

        <Paper className={TableStyles.root}>
          <Table className={TableStyles.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Descricao</TableCell>
                <TableCell>Ficheiros</TableCell>
                <TableCell>Imagens </TableCell>
                <TableCell>  </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {TabelaFicheirosDS && TabelaFicheirosDS.length > 0 &&

                TabelaFicheirosDS.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.tipo}</TableCell>
                    <TableCell>{row.nomeEquip}</TableCell>
                    <TableCell>{row.descricao}</TableCell>
                    
                    <TableCell>
                      {row.ficheiros && row.ficheiros.length > 0 &&
                        row.ficheiros.map((file, index) => (
                          <span>{file.name}<br /></span>
                        ))
                      }
                    </TableCell>
                    <TableCell>
                      {row.imagens && row.imagens.length > 0 &&
                        row.imagens.map((file, index) => (
                          <span>{file.name}<br /></span>
                        ))
                      }
                    </TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="opções"
                        onClick={() => { handleOpenModalWithInfoFichasTecnicas(index) }}>
                        <EditIcon />
                      </IconButton></TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="opções"
                        onClick={() => { handleDeleteCurrentInfoFichasTecnicas(index) }}>
                        <DeleteIcon />
                      </IconButton></TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Paper>
        {/* //#endregion DATASHEETS  */}


        <Divider />




        {/* #region MANUALS  */}
        <CardContent>
          <CardContent>
            <CardHeader
              subheader="Manuais"
              action={
                <IconButton
                  aria-label="opções"
                  onClick={handleClickM}>
                  <MoreVertIcon />
                </IconButton>
              } />
            <Menu
              id="long-menu-M"
              anchorEl={anchorE2}
              keepMounted
              open={open2}
              onClose={handleCloseM}>
              <MenuItem key="MCooling" onClick={abreMColling}>cooling</MenuItem>
              <MenuItem key="MSecurity" onClick={abreMSecurity}>security</MenuItem>
              <MenuItem key="MPower" onClick={abreMPower}>power</MenuItem>
              <MenuItem key="MMMonitoring" onClick={abreMMonitoring}>monitoring</MenuItem>
              <MenuItem key="MMonitoring" onClick={abreMDatacenter}>datacenter</MenuItem>
              <MenuItem key="Monitoring" onClick={abreMNetworking}>networking</MenuItem>
            </Menu>
            <Dialog
            disableBackdropClick
              fullWidth="500"
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={ModalopenM}
              onClose={ModalhandleCloseM}>
              <DialogTitle id="tipoM">{valuesM.tipo}</DialogTitle>

              <DialogContent dividers>
                <CardContent>

                  <TextField
                    fullWidth
                    id="nomeEquipM"
                    label="Nome do equipamento"
                    name="nomeEquipM"
                    rows={1}
                    rowsMax={4}
                    multiline={true}
                    type="text"
                    variant="outlined" />
                </CardContent>
                <CardContent>
                  <DropzoneArea
                    id="ficheirosM"
                    showFileNames={true}
                    maxFileSize={5000000000}
                    onChange={handleChangeFileM}
                    dropzoneText="Clicar ou largar Ficheiros"
                    acceptedFiles={[".pdf"]}

                    filesLimit={6}
                  />
                </CardContent>
                <CardContent>
                  <DropzoneArea
                    id="imagensM"

                    showFileNames={true}
                    onChange={handleChangeImgM}
                    dropzoneText="Clicar ou largar Imagem"
                    acceptedFiles={[".jpg,.png"]}
                    maxFileSize={5000000000}
                    filesLimit={6}
                  />
                </CardContent>
              </DialogContent>
              <DialogActions>
              <Button onClick={ModalhandleCloseM} color="primary">
                  Cancelar
                  
          </Button>
                <Button onClick={guardarItemM} color="primary">
                  Guardar
          </Button>
              </DialogActions>
            </Dialog>
          </CardContent>
        </CardContent>



        <Paper className={TableStyles.root}>
          <Table className={TableStyles.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Ficheiros</TableCell>
                <TableCell>Imagens</TableCell>
                <TableCell>  </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {TabelaFicheirosM && TabelaFicheirosM.length > 0 &&

                TabelaFicheirosM.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.tipo}</TableCell>
                    <TableCell>{row.nomeEquip}</TableCell>
                    <TableCell>
                      {row.ficheiros && row.ficheiros.length > 0 &&
                        row.ficheiros.map((file, index) => (
                          <span>{file.name}<br /></span>
                        ))
                      }
                    </TableCell>

                    <TableCell>
                      {row.imagens && row.imagens.length > 0 &&
                        row.imagens.map((file, index) => (
                          <span>{file.name}<br /></span>
                        ))
                      }
                    </TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="opções"
                        onClick={() => { handleOpenModalWithInfoManuais(index) }}>
                        <EditIcon />
                      </IconButton></TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="opções"
                        onClick={() => { handleDeleteCurrentInfoManuais(index) }}>
                        <DeleteIcon />
                      </IconButton></TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Paper>
        {/* //#endregion MANUALS  */}








        <CardContent>
          <CardHeader
            subheader="Assistência"
          />
          <CardContent>
            <CardHeader
              subheader="Emails"
            />
            <TextField
              fullWidth
              label="Email Suporte"
              name="emailSuporte"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChangeemailSuporte}
              type="text"
              value={values.emailSuporte}
              variant="outlined"
            />
            <div id="resultadoemailSuporte"></div>
          </CardContent>
          <CardContent>
            <TextField
              fullWidth
              label="Email Comercial"
              name="emailComercial"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChangeemailComercial}
              type="text"
              value={values.emailComercial}
              variant="outlined"
            />
            <div id="resultadoemailComercial"></div>
          </CardContent>
          <CardContent>
            <TextField
              fullWidth
              label="Email Botão"
              name="emailbotao"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChangeemailBotao}
              type="text"
              value={values.emailbotao}
              variant="outlined"
            />
            <div id="resultadoemailBotao"></div>
          </CardContent>
          <CardContent>
            <CardHeader
              subheader="Moradas"
            />
            <TextField
              fullWidth
              label="Morada Porto"
              name="moradaPorto"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.moradaPorto}
              variant="outlined"
            />
          </CardContent>
          <CardContent>
            <TextField
              fullWidth
              label="Morada Lisboa"
              name="moradaLisboa"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.moradaLisboa}
              variant="outlined"
            />
          </CardContent>
          <CardContent>
            <CardHeader
              subheader="Contactos"
            />
            <TextField
              fullWidth
              label="Contacto Porto"
              name="contactoPorto"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.contactoPorto}
              variant="outlined"
            />
          </CardContent>
          <CardContent>
            <TextField
              fullWidth
              label="Contacto Lisboa"
              name="contactoLisboa"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.contactoLisboa}
              variant="outlined"
            />
          </CardContent>
        </CardContent>
        <Divider />



        <CardContent>
          <CardHeader
            subheader="Registo Utilizador"
          />
          <CardContent>
            <TextField
              fullWidth
              label="Email"
              name="emailRegisto"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChangeemailRegisto}
              type="email"
              value={values.emailRegisto}
              variant="outlined"
            />
          </CardContent>


          <CardContent>
            <TextField
              fullWidth
              label="Password Registo"
              id="passwordRegisto"
              name="passwordRegisto"
              type="password"
              rows={1}
              onChange={handleChangepasswordRegisto}
              value={values.passwordRegisto}
              variant="outlined"
            />
          </CardContent>

          <CardContent>
            <TextField
              fullWidth
              label="Confirmar Password"
              id="confirmarPassword"
              name="confirmarPassword"
              type="password"
              rows={1}
              onChange={handleChange}
              value={values.confirmarPassword}
              variant="outlined"
            />
            <div id="resultadoPass"></div>
          </CardContent>

        </CardContent>
        <Divider />



        <CardContent>
          <CardHeader
            subheader="Telas/Ensaios"
          />
          <CardContent>
            <TextField
              fullWidth
              style={{display:'none'}}
              label="Nome Manutencao"
              name="nomeManutencao"
              rows={1}
              rowsMax={4}
              multiline={true}
              onChange={handleChange}
              type="text"
              value={values.nomeManutencao}
              variant="outlined"
            />
          </CardContent>
          <CardContent>
            <DropzoneArea
              showFileNames={true}
              maxFileSize={5000000000}
              onChange={handleChangeFileManutencoes}
              dropzoneText="Clicar ou largar Ficheiros"
              acceptedFiles={[".pdf"]}
              filesLimit={6}
            />
          </CardContent>
        </CardContent>
        <Divider />

        <Button onClick={guardarDadosTotais} color="primary">
          Guardar
          </Button>
          {values.emailRegisto!="" && values.passwordRegisto!="" 
          && scorePassword(values.passwordRegisto)>=60 && values.passwordRegisto==values.confirmarPassword
          && 
                <Button onClick={finalizarDossier} color="primary">
                Finalizar
                </Button>
          }
    
      </form>
    </Card >
  );
};

BasicConfigurations.propTypes = {
  className: PropTypes.string
};

export default lifecycle(methods)(BasicConfigurations);
